import {combine, merge, sample} from 'effector';

import {RestError, showRestError} from 'core/errors';
import {initFiltersTable, initSortingsTable} from 'core/hooks/grid2.0';
import {mapFilters, mapSortings} from 'utils/grid-mappers';

import {
    data$,
    defaultFilters,
    defaultSortings,
    fetchDataFx,
    fetchTotalCountFx,
    filters$,
    filtersChanged,
    filtersReset,
    Gate,
    pageNumber$,
    pageSize$,
    sortings$,
    sortingsChanged,
    sortingsReset,
    tableStateChanged,
    totalCount$,
    stateReset,
} from './index';

pageNumber$.reset(filtersChanged, sortingsChanged, stateReset);
pageSize$.reset(stateReset);

initFiltersTable(filters$, filtersChanged, filtersReset, defaultFilters, stateReset);
initSortingsTable(sortings$, sortingsChanged, sortingsReset, defaultSortings, stateReset);

data$.on(fetchDataFx.done, (state, {result}) => result).reset(Gate.close);
totalCount$.on(fetchTotalCountFx.done, (_, {result}) => result).reset(Gate.close);

sample({
    clock: merge([Gate.open, tableStateChanged]),
    source: combine({
        sortings: sortings$,
        pageNumber: pageNumber$,
        pageSize: pageSize$,
        filters: filters$,
    }),
    fn: ({pageNumber, pageSize, filters, sortings}) => ({
        paging: {
            pageNumber,
            pageSize,
        },
        filters: mapFilters(filters),
        sortings: mapSortings(sortings),
    }),
    target: fetchDataFx,
});

sample({
    clock: merge([Gate.open, filtersChanged, filtersReset]),
    source: combine({
        filters: filters$,
    }),
    fn: ({filters}) => ({
        filters: mapFilters(filters),
    }),
    target: fetchTotalCountFx,
});

merge([fetchDataFx.fail, fetchTotalCountFx.fail]).watch(({error}) =>
    showRestError(error as RestError),
);
